module.exports = __webpack_public_path__ + "static/media/rotation.70d49678.gif";